import { render, staticRenderFns } from "./index.vue?vue&type=template&id=131054a6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=131054a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131054a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})


/* vuetify-loader */
import installDirectives from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Scroll } from 'vuetify/lib/directives'
installDirectives(component, {Scroll})
